module.exports = __webpack_public_path__ + "img/deco-couleur.b86aaf3.png";